import React, { useMemo, useState } from 'react'
import axios from 'axios'
import { format } from 'date-fns'
import {
    applyTrainerVerificationUpdate,
    getTrainerVerificationFields,
    getVerificationActorName,
    studentDetailVerificationFields,
} from '../studentDetailVerification'
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from '../successMessage'

const TrainerFieldVerification = ({
    children,
    currentEoi,
    database,
    userData,
    fieldKey,
    fieldValue,
    onUpdated,
}) => {
    const [loading, setLoading] = useState(false)

    const trainerFields = useMemo(
        () => getTrainerVerificationFields(currentEoi?.data),
        [currentEoi]
    )

    const currentField = trainerFields[fieldKey]
    const isChecked = !!currentField?.checked
    const fieldConfig = studentDetailVerificationFields.find((field) => field.key === fieldKey)

    if (!currentEoi || !database || !userData || !fieldConfig) {
        return children
    }

    const handleToggle = async () => {
        const nextChecked = !isChecked
        const actorName = getVerificationActorName(userData)
        const actorId = userData.id || userData.trainerId || userData.email || ''

        try {
            setLoading(true)
            showLoadingMessage(nextChecked ? 'Verifying Student Detail' : 'Removing Student Detail Verification')
            await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/updateTrainerDetailVerification', {
                database,
                documentId: currentEoi.id,
                fieldKey,
                checked: nextChecked,
                actorName,
                actorId,
                fieldValue: fieldValue || '',
                fieldLabel: fieldConfig.label,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            })

            onUpdated && onUpdated(applyTrainerVerificationUpdate({
                currentEoi,
                fieldKey,
                checked: nextChecked,
                actorName,
                actorId,
                fieldValue: fieldValue || '',
                fieldLabel: fieldConfig.label,
            }))
            showSuccessMessage(nextChecked ? 'Student detail verified' : 'Student detail marked as not verified')
        } catch (e) {
            clearPageMessage()
            showWarningMessage('Student detail verification could not be updated. Please try again.')
            console.error('trainer verification update failed', e)
        } finally {
            setLoading(false)
        }
    }

    const helperText = currentField?.checkedAt
        ? `${currentField.checkedBy || 'Trainer'} checked ${format(new Date(currentField.checkedAt), 'dd MMM yyyy hh:mm a')}`
        : 'Not checked yet'

    return (
        <div className='trainerFieldRow'>
            <div className='trainerFieldContent'>
                {children}
                <p className='trainerFieldMeta'>{helperText}</p>
            </div>
            <button
                type='button'
                disabled={loading}
                className={`detailConfirmationTick trainerInlineTick modernVerificationTick ${isChecked ? 'checked' : ''}`}
                onClick={handleToggle}
                aria-label={isChecked ? 'Remove verification' : 'Verify this detail'}
                title={isChecked ? 'Verified — click to remove' : 'Click to verify'}
            >
                {loading ? '...' : '✓'}
            </button>
        </div>
    )
}

export default TrainerFieldVerification
